<template>
  <el-card class="box-card">
    <el-form ref="form" label-width="120px" style="width: 700px">
      <el-form-item label="项目集名称:">
        <el-input v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item label="所属公司:">
        <el-select
          v-model="form.companyId"
          filterable
          remote
          clearable
          placeholder="请选择"
          :remote-method="getCompany"
          @clear="getCompany"
        >
          <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属协会:">
        <el-select
          v-model="form.associationId"
          filterable
          remote
          clearable
          placeholder="请选择"
          :remote-method="getAssociation"
          @clear="getAssociation"
        >
          <el-option v-for="item in associationList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="添加项目:">
        <el-button type="primary" icon="el-icon-plus" circle @click="openAddProject"></el-button>
      </el-form-item>
      <el-form-item label="项目名称:" v-for="(item, index) in form.projectList" :key="index">
        <el-input v-model.trim="item.name" style="width: 220px"></el-input>
        <span style="display: inline-block; width: 100px; text-align: right; margin-right: 10px">项目日期:</span>
        <el-date-picker v-model="item.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd 23:59:59">
        </el-date-picker>
      </el-form-item>
      <el-form-item style="margin-top: 40px">
        <el-button type="warning" @click="closePage()">取 消</el-button>
        <el-button type="primary" @click="saveHandle()">保 存</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="添加项目" :visible.sync="showDialog" width="30%" center>
      <div>
        <span>项目期数: &nbsp;&nbsp;&nbsp;</span>
        <el-input-number v-model="projectNum" :min="1" :max="9999"></el-input-number>
        <span>期</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="addProject">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script scoped>
import requestApi from '@/api/thirdManage/labour'
export default {
  data() {
    return {
      form: {
        name: '',
        companyId: '',
        associationId: '',
        projectList: []
      },
      projectNum: 1,
      showDialog: false,
      companyList: [],
      associationList: []
    }
  },
  props: {
    PAGEKEY: {
      type: String,
      default: () => ''
    },
    PAGEBACK: {
      type: String,
      default: () => ''
    }
  },
  mounted() {
    this.getCompany()
    this.getAssociation()
  },
  methods: {
    // 获取所属公司
    getCompany(val) {
      requestApi
        .companyPages({
          name: val,
          pageIndex: 1,
          pageSize: 20
        })
        .then((res) => {
          if (res.Success) {
            this.companyList = res.Data.dataList || []
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch((res) => {
          this.$message.error('列表获取失败，请稍后再试！')
        })
    },
    // 获取所属协会
    getAssociation(val) {
      requestApi
        .associationPages({
          name: val,
          pageIndex: 1,
          pageSize: 20
        })
        .then((res) => {
          if (res.Success) {
            this.associationList = res.Data.dataList || []
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch((res) => {
          this.$message.error('列表获取失败，请稍后再试！')
        })
    },
    openAddProject() {
      if (this.form.name === '') {
        this.$message.warning('请先输入项目集名称')
        return
      }
      this.showDialog = true
    },
    addProject() {
      if (this.projectNum) {
        this.showDialog = false
        this.form.projectList = this.form.projectList.concat(
          Array.from({ length: this.projectNum }, (_, i) => {
            return {
              name: `${this.form.name}第${i + 1}期`,
              date: ''
            }
          })
        )
        this.projectNum = 1
      }
    },
    isNonEmpty(value) {
      // 如果是字符串，检查是否非空
      if (typeof value === 'string') {
        return value.trim() !== ''
      }
      // 如果是数组，检查每个元素
      if (Array.isArray(value)) {
        return value.every((item) => this.isNonEmpty(item))
      }
      // 如果是对象，检查每个属性
      if (value && typeof value === 'object') {
        return Object.values(value).every((val) => this.isNonEmpty(val))
      }
      // 其他类型（如数字、布尔值等）视为非空
      return true
    },
    saveHandle() {
      const isValid = this.isNonEmpty(this.form)
      if (!isValid) {
        this.$message.warning('请填写完所有选项信息')
        return
      }
      requestApi
        .saveProjectList(this.form)
        .then((res) => {
          if (res.Success) {
            this.$message.success('保存成功')
            this.closePage()
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch((res) => {
          this.$message.error('保存失败，请稍后再试！')
        })
    },
    //取消钩子
    closePage() {
      this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
      this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/thirdManage/labourmanage/components/page.vue